export default __webpack_public_path__ + "static/media/logo_white.e84b4247.png";